module.exports = __webpack_public_path__ + "img/piece.36473133.svg";